import { Department, DepartmentTableRow } from '../../../../pages/admin-dashboard/departments/departments.model';

export function toDepartmentTableRows(
  departments: Department[],
  startIndex: number,
  isArabic: boolean,
): DepartmentTableRow[] {
  return departments.map((department, index) => ({
    id: department.id,
    rowNumber: startIndex + index + 1,
    title: isArabic ? department.titleAr : department.titleEn,
    createdOn: department.createdOn,
    createdBy: department.createdBy,
    lastModifiedOn: department.lastModifiedOn,
    lastModifiedBy: department.lastModifiedBy,
    _original: department,
  }));
}
